import { storage } from '../client/index';
import { ref, uploadBytes, getDownloadURL, uploadString } from 'firebase/storage';

export const uploadImage = async (filename, image) => {
  try {
    const imagePath = ref(storage, `images/${filename}`);
    await uploadBytes(imagePath, image);
    const url = await getDownloadURL(imagePath);
    return url;
  } catch (err) {
    return err;
  }
}

export const uploadBase64 = async (filename, image) => {
  try {
    const imagePath = ref(storage, `images/${filename}`);
    await uploadString(imagePath, image);
    const url = await getDownloadURL(imagePath);
    return url;
  } catch (err) {
    return err;
  }
}